import styled from 'styled-components';

export const OfferInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  font-size: 11px;
  color: #666;
  line-height: 1.3;
  flex: 1;
`;

export const OfferInfoSection = styled.div<{ textAlign?: 'left' | 'right' }>`
  flex: 1;
  text-align: ${props => props.textAlign || 'left'};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
